import React from "react";
import { Link } from "react-router-dom";
import { dishes } from "../data/dishes";
import { useTheme, useDocumentTitle, useSite } from "../hooks/useSite";
import FoodImage from "../components/FoodImage";
import { Host } from "../illustrations";

export default function EducationPage() {
  useTheme(dishes[0]);
  useDocumentTitle("What is RollOver?");
  const { openModal } = useSite();
  return (
    <>
      <section className="ro-education-intro">
        <div className="ro-container ro-split">
          <div>
            <h1>
              <strong className="ro-italic">RollOver</strong>
              <br />
              <span className="ro-outline">is here.</span>
            </h1>
            <p className="ro-education-intro__sub">(What’s your mood?)</p>
          </div>
          <FoodImage dish={dishes[0]} className="ro-education-intro__food" animate />
        </div>
      </section>
      <div className="ro-editorial-body">
        <section className="ro-section">
          <div className="ro-container ro-container--narrow">
            <h2>
              It starts with a <span className="ro-outline">craving.</span>
            </h2>
            <p>
              Some days call for something cheesy. Others need a little chocolate, a cool dessert or a familiar café break. RollOver brings those moods together in one friendly, local café in Hanamkonda.
            </p>
            <p>
              RollOver started with hand-crafted ice cream rolls, the Thai-style dessert rolled fresh on a cold plate, and grew into a menu of sundaes, waffle cones, shakes, momos, munchies, burgers and sandwiches.
            </p>
          </div>
        </section>
        <section className="ro-section ro-tinted">
          <div className="ro-container ro-split">
            <div className="ro-education-illustration ro-bob">
              <Host />
            </div>
            <div>
              <h2>
                A little <span className="ro-outline">sweet.</span>
                <br />A little <strong className="ro-italic">savoury.</strong>
              </h2>
              <p>
                Browse by the dish that catches your eye. Seven showcase dishes introduce the menu; the full menu lists every category with vegetarian and non-vegetarian markers.
              </p>
              <Link to="/menu" className="ro-pill" style={{ marginTop: 30 }}>
                Explore our menu
              </Link>
            </div>
          </div>
        </section>
        <section className="ro-section">
          <div className="ro-container ro-container--narrow">
            <h2>
              Made for <span className="ro-outline">café moments.</span>
            </h2>
            <p>
              A catch-up with friends. A break between plans. A sweet ending to the afternoon. The promise is simple: “Good Food. Good Mood. Great Times.”
            </p>
            <div className="ro-moments">
              {[
                ["Taste", "Lead with food and the feeling it creates."],
                ["Joy", "Make everyday cravings feel like a small celebration."],
                ["Sharing", "Birthdays, farewells and get-togethers, in-store or outdoors."],
                ["Local warmth", "A helpful café team in Hanamkonda, Warangal."],
              ].map(([t, d]) => (
                <div className="ro-moment" key={t}>
                  <h3 className="ro-italic">{t}</h3>
                  <p>{d}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="ro-section ro-tinted">
          <div className="ro-container ro-split">
            <div>
              <h2>
                Find your <span className="ro-outline">next bite.</span>
              </h2>
              <p>
                Use the dish pages for a closer look, the pairings collection for a little inspiration and Find Us for the location. Online ordering happens on Swiggy or Zomato.
              </p>
              <button type="button" className="ro-pill" style={{ marginTop: 30 }} onClick={() => openModal("order")}>
                Explore ordering
              </button>
            </div>
            <FoodImage dish={dishes[1]} className="ro-education-intro__food" />
          </div>
        </section>
      </div>
    </>
  );
}
